/**
 * version.ts - Version and build information for FMwvTool
 * 
 * CHANGE HISTORY:
 * - 251110_2245 danielbeer: Changed to import version from package.json (single source of truth)
 * - 251108_1630 [pending] danielbeer: Added proper semantic versioning and CHANGE HISTORY
 * - 251108_1427 [pending] danielbeer: Initial creation with version display
 * 
 * Semantic Versioning: MAJOR.MINOR.PATCH
 * - MAJOR: Breaking changes (e.g., 3.x.x → 4.0.0)
 * - MINOR: New features (e.g., 4.0.0 → 4.1.0)
 * - PATCH: Bug fixes (e.g., 4.1.0 → 4.1.1)
 * 
 * BEST PRACTICE: Version is imported from package.json (single source of truth)
 * This ensures version is always in sync and updated automatically by version management tools.
 */

// Import version from package.json - single source of truth
import packageJson from '../package.json';

// Semantic version following x.x.x format
export const VERSION = packageJson.version;

// Build timestamp in yymmdd-hhmmss format
const now = new Date();
const yy = String(now.getFullYear()).slice(-2);
const mm = String(now.getMonth() + 1).padStart(2, '0');
const dd = String(now.getDate()).padStart(2, '0');
const hh = String(now.getHours()).padStart(2, '0');
const min = String(now.getMinutes()).padStart(2, '0');
const ss = String(now.getSeconds()).padStart(2, '0');

export const BUILD_TIMESTAMP = `${yy}${mm}${dd}-${hh}${min}${ss}`;

// ISO format for full timestamp
export const BUILD_TIMESTAMP_ISO = now.toISOString();

// Human-readable build date
export const BUILD_DATE = now.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric'
});

// Human-readable build time
export const BUILD_TIME = now.toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit'
});
